// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__vVezi","title":"styles_title__HroXf"};